module.exports = __webpack_public_path__ + "static/avatar-b4e2172acf12a55315f20614674cf492.png";